import { ReactNode, Fragment, CSSProperties } from 'react';
import { IFeatureBase, IFeatureTheme } from 'mod/featureV2/interface';
import { getContainerThemeProps } from 'mod/featureV2/utils';
import cn from 'classnames';

export type IFeaturesRenderProps<T> = {
    containerTheme?: IFeatureTheme;
    features?: T[];
    render: (props: { feature: T }) => ReactNode;
    id?: string;
    className?: string;
    style?: CSSProperties;
};

export function FeaturesRender<T extends IFeatureBase = IFeatureBase>(props: IFeaturesRenderProps<T>) {
    const { containerTheme, features, render, id, className, style } = props;
    if (!features || features.length === 0) {
        return null;
    }

    const themeProps = getContainerThemeProps(containerTheme);

    return (
        <div
            id={id}
            className={cn(themeProps.className, className)}
            style={{ ...themeProps.style, ...style }}
        >
            {features.map((feature, index) => (
                <Fragment key={index}>
                    {render({ feature })}
                </Fragment>
            ))}
        </div>
    )
}